'use client';

import { createContext, useContext } from 'react';
import { useGetUserData } from '@/context/UserProvider/hooks/useGetUserData';
import type { User } from '@/types/apiTypes';

export interface UserContextType {
  user: User | null;
  isUserLoading: boolean;
}

const UserContext = createContext<UserContextType>({
  user: null,
  isUserLoading: false,
});

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isPending } = useGetUserData();

  return (
    <UserContext.Provider value={{ user: user?.data || null, isUserLoading: isPending }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};